import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eFeatures, eUserRole } from '../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { VoiceTree, VoiceTreeListResponse } from '../../../models/voiceTreeList';
import { GlobalService } from '../../../services/global.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
import { VoiceCallService } from '../../../services/voice-call.service';

@Component({
  selector: 'app-voice-tree-list',
  templateUrl: './voice-tree-list.component.html',
    styleUrl: './voice-tree-list.component.css',
    providers: [GridConfigurationService]
})
export class VoiceTreeListComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    voiceTreeListSource: MatTableDataSource<any>;
    voiceTreeListDisplayColumns: string[] = [];
    columns = [
        { field: 'srNo', title: '#', width: '50' },
        { field: 'name', title: 'Call Tree', width: '100' },
        { field: 'isActive', title: 'Status', width: '' },
    ];
    private encryptedUser: string = '';
    showSpinner: boolean = false;
    user: CLPUser;
    userResponse: UserResponse;
    msg: string = '';
    roleFeaturePermissions: RoleFeaturePermissions;
    voiceTreeList: VoiceTree[];
    message: string = '';
    messageType: string = '';

    constructor(
        private _globalService: GlobalService,
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private route: ActivatedRoute,
        private _router: Router,
        public _gridCnfgService: GridConfigurationService,
        private _voiceCallService: VoiceCallService,

    ) {

    }
    ngOnInit(): void {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        const msg = this.route.snapshot.queryParamMap.get('msg') || '';
                        this.handleMessageParam(msg);
                        this.voiceTreeGetList();
                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        })
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    const response = UtilityService.clone(result);
                    if (!isNullOrUndefined(response)) {
                        if (!isNullOrUndefined(response?.user)) {
                            this.user = response.user;
                            this.roleFeaturePermissions = response.roleFeaturePermissions;
                            this._gridCnfgService.user = this.user;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("voice-tree-list.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }


    async voiceTreeGetList() {
        await this._voiceCallService.voiceTreeGetList(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID)
            .then(async (result: VoiceTreeListResponse) => {
                if (result && result.messageBool) {
                    var response = UtilityService.clone(result);
                    this.voiceTreeList = response?.voiceTreeList;
                    if (this.voiceTreeList?.length > 0)
                        this.setGrid(this.voiceTreeList);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("voice-tree-list.voiceTreeGetList", err.message,
                    'cLPCompanyID: ' + this.user?.cLPCompanyID + ' cLPUserID: ' + this.user?.cLPUserID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);

    }
    setGrid(list) {
        this.voiceTreeListDisplayColumns = this.columns.map(c => c.field);
        this.voiceTreeListSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.voiceTreeListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = localStorage.getItem('pageSize') ? +localStorage.getItem('pageSize') : 50;
            }
            this.voiceTreeListSource.sort = this.sort;
        }, 500)

    }


    handleMessageParam(msg: string): void {
        if (msg) {
            this.messageType = 'warning';

            switch (msg) {
                case 'unauth':
                    this.message = 'You are not authorized to view this Automation Process.';
                    break;
                case 'cnl':
                    this.message = 'No changes were made.';
                    break;
                case 'noex':
                    this.message = 'Automation Process does not exist.';
                    break;
                case 'del':
                    this.message = 'Automation Process has been deleted successfully.';
                    break;
                case 'campdel':
                    this.message = 'Campaign has been deleted successfully.';
                    break;
                case 'seltoadd':
                    this.message = 'Please choose an Automation Process from the list below and click <i>Add Contacts</i> or <i>Add Leads</i>.';
                    break;
                default:
                    this.message = '';
                    this.messageType = '';
                    break;
            }
        } else {
            this.message = '';
            this.messageType = '';
        }
    }

    getSerialNumber(index: number): number {
        const pageIndex = this.paginator?.pageIndex ?? 0;
        const pageSize = this.paginator?.pageSize ?? 50;
        return (pageIndex * pageSize) + index + 1;
    }
}
